import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-brand">
          <div className="footer-brand-title">
            <img
              src="/vyralnewslogo_1787523012934.png"
              alt="VyralNews — Where Trending Meets Truth"
              className="footer-logo"
            />
          </div>
          <p>
            Your trusted source for breaking news, in-depth analysis, and
            insightful journalism from around the world.
          </p>
        </div>

        <div className="footer-section footer-links">
          <h3>Navigate</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/login">Sign In</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Categories</h3>
          <ul className="footer-categories-grid">
            <li><Link to="/category/politics">Politics</Link></li>
            <li><Link to="/category/world">World</Link></li>
            <li><Link to="/category/business">Business</Link></li>
            <li><Link to="/category/health">Health</Link></li>
            <li><Link to="/category/technology">Technology</Link></li>
            <li><Link to="/category/entertainment">Entertainment</Link></li>
            <li><Link to="/category/sports">Sports</Link></li>
            <li><Link to="/category/local">Local</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-contact">
          <h3>Contact</h3>
          <p>info@vyralmediagroup.com</p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="footer-dot">&middot;</span>
          <Link to="/terms">Terms of Service</Link>
          <span className="footer-dot">&middot;</span>
          <Link to="/payment-policy">Payment Policy</Link>
          <span className="footer-dot">&middot;</span>
          <Link to="/refund-policy">Refund Policy</Link>
          <span className="footer-dot">&middot;</span>
          <Link to="/pricing">Pricing</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} <a href="https://vyralmediagroup.com" target="_blank" rel="noopener noreferrer" className="footer-copyright-link">VyralMediaGroup</a>. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
